var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientsPassive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#4b5c68;}.a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(79 228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81 230)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.583,22.667a.833.833,0,0,1-.693-.371l-1.419-2.129H9.833a.833.833,0,1,1,0-1.667h2.083a.834.834,0,0,1,.693.371l.87,1.305,1.858-3.716a.834.834,0,0,1,.713-.46.822.822,0,0,1,.747.4l2.257,3.763h1.612a.833.833,0,1,1,0,1.667H18.583a.832.832,0,0,1-.714-.4L16.15,18.564l-1.821,3.642a.834.834,0,0,1-.694.459Z",
    transform: "translate(-1.5 -2.667)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4.167,
    cy: 4.167,
    r: 4.167,
    transform: "translate(3.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.833,18.667a2.5,2.5,0,0,1,2.5-2.5h2.083a2.5,2.5,0,0,1,1.215.314l.716-1.433a2.486,2.486,0,0,1,1.845-1.328A4.153,4.153,0,0,0,10.833,12H4.167A4.167,4.167,0,0,0,0,16.167v2.708a.625.625,0,0,0,.625.625H5.987A2.472,2.472,0,0,1,5.833,18.667Z",
    transform: "translate(0 -2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsPassive);
export default __webpack_public_path__ + "static/media/clientsPassive.70d14f2404f4cd925c6122c17a080bee.svg";
export { ForwardRef as ReactComponent };